// extracted by mini-css-extract-plugin
export default {"section1":"Error401_section1__m0ywj"};